import React from "react";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";

export default function SheetHeaderClose({ onClose }: { onClose: () => void }) {
  return (
    <button type="button" className="v2-sheet__close" aria-label="Close" onClick={onClose}>
      <Icon path={mdiClose} size="24px" />
    </button>
  );
}
